module.exports = __webpack_public_path__ + "static/img/logo__.881c9dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo__.png
// module id = xBIX
// module chunks = 1